var bW = document.documentElement.clientWidth;
var bH = document.documentElement.clientHeight;
function resizeWindow(){
  bW = document.documentElement.clientWidth;
  bH = document.documentElement.clientHeight;
}

const headerWidth = 1259;
const breakpoint = 800;




//header nav PC
function isTouchDevice() {
  return window.ontouchstart === null ? true : false;
}
/* if((bW > headerWidth) || !(isTouchDevice())){ */
if((bW > headerWidth)){
  const HeaderLinks = document.querySelectorAll('.c-nav__link.--inlink');
  HeaderLinks.forEach(HeaderLink => {
    HeaderLink.addEventListener('mouseover', function() {
      HeaderLink.classList.add('active');
      if(HeaderLink.nextElementSibling){
        HeaderLink.nextElementSibling.classList.add('active');
        HeaderLink.nextElementSibling.addEventListener('mouseover', function() {
          HeaderLink.classList.add('active');
          HeaderLink.nextElementSibling.classList.add('active');
        });
      }
    });
    HeaderLink.addEventListener('mouseleave', function() {
      HeaderLink.classList.remove('active');
      if(HeaderLink.nextElementSibling){
        HeaderLink.nextElementSibling.classList.remove('active');
        HeaderLink.nextElementSibling.addEventListener('mouseleave', function() {
          HeaderLink.classList.remove('active');
          HeaderLink.nextElementSibling.classList.remove('active');
        });
      }
    });
  });
}



//header sp
/* if((bW <= headerWidth) || (isTouchDevice())){ */
if((bW <= headerWidth)){
  //ham
  const ham = document.querySelector('.c-ham');
  const menu01 = document.querySelector('.c-nav.--main')
  const menu02 = document.querySelector('.c-nav.--catalog')
  const menu03 = document.querySelector('.c-nav.--searcharea')
  const body = document.querySelector('body');
  ham.addEventListener('click', function() {
    ham.classList.toggle('ham-active');
    menu01.classList.toggle('ham-active');
    menu02.classList.toggle('ham-active');
    menu03.classList.toggle('ham-active');
    body.classList.toggle('ham-active');
  });

  //main menu
  const HeaderLinks = document.querySelectorAll('.c-nav__link.--inlink');
  HeaderLinks.forEach(HeaderLink => {
    //1st click
    HeaderLink.addEventListener('click', function(event) {
      if(HeaderLink.classList.contains('active')){
        if(HeaderLink.nextElementSibling){
          HeaderLink.classList.remove('active');
          HeaderLink.nextElementSibling.classList.remove('active');
        };
      } else {
        if(HeaderLink.nextElementSibling){
          HeaderLink.classList.add('active');
          HeaderLink.nextElementSibling.classList.add('active');
          event.preventDefault();
        };
      }
    });
  });
}


//title animation
const h2TitielAnimations = document.querySelectorAll('.c-title.--h2.--primary');
if(h2TitielAnimations){
  h2TitielAnimations.forEach((h2TitielAnimation) => {
    ScrollTrigger.create({
      trigger: h2TitielAnimation,
      start: "top 80%",
      toggleClass: {
          targets: h2TitielAnimation,
          className: "active",
      },
      once: true,
    });
  });
}


// animation -- splitText -- ///////////////////////////////////////
/* function spanWrap() {
  const targets = document.querySelectorAll('.split-text')
  targets.forEach( function (target) {
      let nodes = [...target.childNodes];
      let textBox = '';
      nodes.forEach( function (node) {
      if (node.nodeType == 3) { //テキストの場合
          let text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
          text.split('').forEach(function (t, i) {
              if (t !== " ") {
                if (i < 10) {
                  textBox += '<span class="char c-0' + (i + 1) + '">' + t + '</span>';
                } else {
                  let n = i / 10;
                  textBox += '<span class="char c-0' + (i + 1) + '">' + t + '</span>';
                }
              } else {
                textBox += t;
              }
            });
      } else if (node.contains(node) == true) { // テキストではなく、子ノード(=span要素)を持つ
          // そのまま連結
          textBox = textBox + node.outerHTML;
      } else { // テキストではなく、br要素などspan要素以外の要素を持つ
          // そのまま連結　※br要素などをspan要素とは別に処理する場合はここに書く
          textBox = textBox + node.outerHTML;
        }
      })
      target.innerHTML = textBox
  })
}
spanWrap(); */

// animation top -- catch -- ///////////////////////////////////////

const topCatchAnimation = document.querySelector('body.p-top section.catch');
/* if(topCatchAnimation){
  document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)
    //Initial state title
    const catchTitle = document.querySelectorAll('section.catch span.char');
    const catchDescription = document.querySelector('section.catch .cont p');
    const catchImage = document.querySelector('section.catch .img');
    gsap.set(catchTitle, {
      opacity: 0,
      y: -50,
      rotation: 20
    });
    const topCatchTL01 = gsap.timeline();
    const topCatchEvent = ScrollTrigger.batch(catchTitle, {
      onEnter: batch => topCatchTL01.to(batch, {
        opacity: 1, 
        y: 0, 
        stagger: 0.08,
        overwrite: true
      }).to(batch, {
        rotation: 0,
        stagger: 0.1,
      }, '>0.4').add(() => {
        catchDescription.classList.add('active');
      }, '>1').add(() => {
        catchImage.classList.add('active');
      }, '>0.4'),
      trigger: topCatchAnimation,
      start: 'top 60%',
    });
  });
} */




// slide top -- special -- ///////////////////////////////////////
const topSpecialSlide = new Swiper('.c-slider.--top.--special', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 45,
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: '.swiper-button-next.--special',
    prevEl: '.swiper-button-prev.--special',
  },
  pagination: {
    el: '.swiper-pagination.--special',
  },
  breakpoints: {
    800: {
      slidesPerView: 2,
      centeredSlides: false,
    }
  },
});


// slide top -- work -- ///////////////////////////////////////
const topWorkSlide = new Swiper('.c-slider.--top.--work', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 25,
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: '.swiper-button-next.--work',
    prevEl: '.swiper-button-prev.--work',
  },
  pagination: {
    el: '.swiper-pagination.--work',
  },
  breakpoints: {
    800: {
      slidesPerView: 3,
      centeredSlides: false,
    }
  },
});



// slide top -- topics -- ///////////////////////////////////////
const topTopicsSlide = new Swiper('.c-slider.--top.--topics', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 48,
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: '.swiper-button-next.--topics',
    prevEl: '.swiper-button-prev.--topics',
  },
  pagination: {
    el: '.swiper-pagination.--topics',
  },
  breakpoints: {
    800: {
      slidesPerView: 3,
      centeredSlides: false,
    }
  },
});



// slide single item -- item -- ///////////////////////////////////////
const singleItemItem = document.querySelector('.swiper.c-slider.--singleitem.--item');
if(singleItemItem){
  const singleItemItemSlider = new Swiper(singleItemItem, {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 1000,
    /* autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    }, */
    navigation: {
      nextEl: '.swiper-button-next.--singleitem.--item',
      prevEl: '.swiper-button-prev.--singleitem.--item',
    },
    pagination: {
      el: '.swiper-pagination.--singleitem.--item',
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      1200: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });
}




// slide single item -- term -- ///////////////////////////////////////
const singleItemTerm = document.querySelector('.swiper.c-slider.--singleitem.--term');
if(singleItemTerm){
  const singleItemTermSlider = new Swiper(singleItemTerm, {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 1000,
    /* autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    }, */
    navigation: {
      nextEl: '.swiper-button-next.--singleitem.--term',
      prevEl: '.swiper-button-prev.--singleitem.--term',
    },
    pagination: {
      el: '.swiper-pagination.--singleitem.--term',
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      1200: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });
}




// slide single item -- category -- ///////////////////////////////////////
const singleItemCategory = document.querySelector('.swiper.c-slider.--singleitem.--category');
if(singleItemCategory){
  const singleItemCategorySlider = new Swiper(singleItemCategory, {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 1000,
    /* autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    }, */
    navigation: {
      nextEl: '.swiper-button-next.--singleitem.--category',
      prevEl: '.swiper-button-prev.--singleitem.--category',
    },
    pagination: {
      el: '.swiper-pagination.--singleitem.--category',
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      1200: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });
}




// slide single takao_works -- kv -- ///////////////////////////////////////
const singleTakaoWorks = document.querySelector('.swiper.c-slider.--single-takao_works');
if(singleTakaoWorks){
  const singleTakaoWorksSlider = new Swiper(singleTakaoWorks, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1000,
    /* autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    }, */
    navigation: {
      nextEl: '.swiper-button-next.--single-takao_works',
      prevEl: '.swiper-button-prev.--single-takao_works',
    },
  });
}




// slide single takao_works -- current area -- ///////////////////////////////////////
const singleTakaoWorksCurrentarea = document.querySelector('.swiper.c-slider.--single-takao_works.--currentarea');
if(singleTakaoWorksCurrentarea){
  const singleTakaoWorksCurrentareaSlider = new Swiper(singleTakaoWorksCurrentarea, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1000,
    /* autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    }, */
    navigation: {
      nextEl: '.swiper-button-next.--single-takao_works.--currentarea',
      prevEl: '.swiper-button-prev.--single-takao_works.--currentarea',
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 40,
        centeredSlides: false,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 60,
        centeredSlides: false,
      },
    },
  });
}




// slide single takao_works -- area -- ///////////////////////////////////////
const singleTakaoWorksArea = document.querySelector('.swiper.c-slider.--single-takao_works.--area');
if(singleTakaoWorksArea){
  const singleTakaoWorksAreaSlider = new Swiper(singleTakaoWorksArea, {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 1000,
    /* autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    }, */
    navigation: {
      nextEl: '.swiper-button-next.--single-takao_works.--area',
      prevEl: '.swiper-button-prev.--single-takao_works.--area',
    },
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: false,
      },
      900: {
        slidesPerView: 4,
        spaceBetween: 50,
        centeredSlides: false,
      },
    },
  });
}


// slide commitment -- factory -- ///////////////////////////////////////
const commitmentFactorySlide = new Swiper('.--factory.wp-block-lazyblock-lower-page-slider .c-slider.--commitment', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 45,
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: '.--factory.wp-block-lazyblock-lower-page-slider .swiper-button-next.--special',
    prevEl: '.--factory.wp-block-lazyblock-lower-page-slider .swiper-button-prev.--special',
  },
  pagination: {
    el: '.--factory.wp-block-lazyblock-lower-page-slider .swiper-pagination.--special',
  },
  breakpoints: {
    800: {
      slidesPerView: 2,
      centeredSlides: false,
    }
  },
});


// slide commitment -- machine -- ///////////////////////////////////////
const commitmentMachineSlide = new Swiper('.--machine.wp-block-lazyblock-lower-page-slider .c-slider.--commitment', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 45,
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: '.--machine.wp-block-lazyblock-lower-page-slider .swiper-button-next.--special',
    prevEl: '.--machine.wp-block-lazyblock-lower-page-slider .swiper-button-prev.--special',
  },
  pagination: {
    el: '.--machine.wp-block-lazyblock-lower-page-slider .swiper-pagination.--special',
  },
  breakpoints: {
    800: {
      slidesPerView: 2,
      centeredSlides: false,
    }
  },
});






//desvg
window.addEventListener('load', function(){
  deSVG('.desvg', true);
});

//body
document.querySelector('#body').classList.add('show');